import { render } from "./PermissionList.vue?vue&type=template&id=000f3064&scoped=true&ts=true"
import script from "./PermissionList.vue?vue&type=script&lang=ts"
export * from "./PermissionList.vue?vue&type=script&lang=ts"

import "./PermissionList.vue?vue&type=style&index=0&id=000f3064&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000f3064"]])

export default __exports__